import { useEffect } from "react";
import {
  useMediaQuery,
  useToast,
} from "@chakra-ui/react";
import PaymentDrawer from "./PaymentDrawer";
import CustomDrawer from "../../../components/CustomDrawer";
import { mailCreditsStore } from "../../../hooks/store";
import { useSnapshot } from "valtio";
import InAppCreditsButton from "./InAppCreditsButton";
export { BalanceCmp } from "./InAppCreditsButton";

const InAppCredits = () => {
  const { inAppCredits, latestCreditsPurchase, isMailCreditsDrawerOpen } = useSnapshot(mailCreditsStore);
  const [isSmallerThan425] = useMediaQuery("(max-width: 425px)");

  const toast = useToast({
    position: "top",
    containerStyle: {
      zIndex: 9,
    },
  });

  useEffect(() => {
    if (latestCreditsPurchase !== 0) {
      toast({
        status: "success",
        description:
          "credit purchase of " + latestCreditsPurchase + " successful.",
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [latestCreditsPurchase]);

  return (
    <>
      <InAppCreditsButton
        credits={inAppCredits.balance}
        onClick={() => {
          mailCreditsStore.isMailCreditsDrawerOpen = true;
        }}
      />
      <CustomDrawer
        placement={isSmallerThan425 ? "bottom" : "right"}
        isOpen={isMailCreditsDrawerOpen}
        onClose={() => {
          mailCreditsStore.isMailCreditsDrawerOpen = false;
        }}
        h={isSmallerThan425 ? "100%" : "full"}
        content={<PaymentDrawer onClose={() => {
          mailCreditsStore.isMailCreditsDrawerOpen = false;
        }} />}
        borderTopRadius={0}
      />
    </>
  );
};

export default InAppCredits;
